import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as GasTheIcon } from '../../assets/icons/gas-the.svg';

const GasThe = ({ scale = 1 }) => (
  <div>
    <GasTheIcon
      style={{ width: (24 * scale), height: (24 * scale) }}
    />
  </div>
);

GasThe.propTypes = {
  scale: PropTypes.number,
};

export default GasThe;
